// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container__wid7E","item":"List_item__WnIVR"};